<chart *ngIf="!loading" [chartType]="'line'" [chartLabels]="chartLabels" [dataSet]="chartData" [options]="chartOptions"></chart>
<mat-spinner *ngIf="loading"></mat-spinner>